import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react'
import { SpinnerCircular } from 'spinners-react';
import { useAddRecordMutation, useLazyGetRecordsQuery } from '../../services/agencyApi';
import CustomForm from '../components/CustomForm';
import Footer from '../Layout/footer';
import Header from '../Layout/header'
import bgimg from './../../images/background/bg2.jpg';
import "react-multi-toggle/style.css";
import { createYupSchema } from '../components/YupSchemaCreator';
import * as Yup from "yup";
import { ToastContainer } from 'react-toastify';
import CustomFormSubmit from '../components/CustomFormSubmit';
import _ from 'lodash';

const KickStarter = () => {
    const [isFocused, setIsFocused] = useState(false);
    const [selected, setSelected] = useState({});
    const [initialValues, setInitialValues] = useState({});
    const [formData, setFormData] = useState();
    const [addRecord, { isLoading: isAddingRecord }] = useAddRecordMutation();
    const [userInfo, setUserInfo] = useState({});
    const [successHandler, setSuccessHandler] = useState(true);

    const [
        getRecords,
        {
            data: formDataList,
            isLoading,
        }
    ] = useLazyGetRecordsQuery();
    useEffect(() => {
        getRecords({
            entity: `Survey/GetQuestionsBySurvey/${process.env.REACT_APP_KICKSTARTER_SURVEY}`,
        })
    }, [])

    useEffect(() => {
        formDataList && setFormData(formDataList)
    }, [formDataList])

    useEffect(() => {
        if (formData) {
            const response = formData.questions.reduce((obj, val) => {
                return { ...obj, [`${val.questionType.name.replace(/\s/g, '')}${val.id}`]: "" }
            }, {})
            setInitialValues(response)
        }
    }, [formData])

    useEffect(() => {
        setUserInfo({
            appCodeName: window.clientInformation.appCodeName,
            appName: window.clientInformation.appName,
            appVersion: window.clientInformation.appVersion,
            language: window.clientInformation.language,
            platform: window.clientInformation.platform,
            userAgentData: window && window.clientInformation && window.clientInformation.userAgentData && window.clientInformation.userAgentData.platform,
            hostname: window.location.hostname,
            host: window.location.host,
            origin: window.location.origin,
            protocol: window.location.protocol,
            referer: window.location.href,
        })
    }, [])

    const yupSchema = formData && formData.questions.reduce(createYupSchema, {});
    const validateSchema = Yup.object().shape(yupSchema);

    const submitForm = (values) => {
        CustomFormSubmit(values, formData, addRecord, setSuccessHandler, successHandler, userInfo)
    }

    const findInputType = (type) => {
        switch (type) {
            case 'string':
                return 'text'
            case 'email':
                return 'email'
            case 'number':
                return 'text'
            case 'Multiline Text':
                return 'textarea'
            case 'multiple-toggle':
                return 'toggle'
            case 'checkbox':
                return 'checkbox'
            default:
                break
        }
    }
    const findInputIcon = (type) => {
        switch (type) {
            case 'string':
                return 'user'
            case 'number':
                return 'mobile'
            case 'email':
                return 'email'
            case 'file':
                return 'file'
            case 'Multiline Text':
                return 'agenda'
            case 'checkbox':
                return 'checkbox'
            default:
                break
        }
    }
    return (
        <>
            <Header />
            <div className="full-section">
                <div className="dlab-bnr-inr overlay-primary-dark contact-page" style={{ backgroundImage: "url(" + bgimg + ")" }}>
                    <div className="container">
                        <div className="row">
                            <ToastContainer autoClose={5000} hideProgressBar />
                            <div className="col-lg-12 col-xs-12">
                                <Formik
                                    initialValues={initialValues}
                                    validationSchema={validateSchema}
                                    onSubmit={submitForm}
                                    enableReinitialize={true}
                                >
                                    {(formik) => {
                                        const { errors, touched, handleBlur, setFieldValue, handleChange, values } = formik;
                                        return (
                                            <Form className="inquiry-form dzForm d-flex justify-content-center align-content-center consultation-form" action="script/contact.php">
                                                {
                                                    isLoading ? <SpinnerCircular color='white' thickness={100} secondaryColor="black" /> :
                                                        <div>
                                                            <div className="dzFormMsg"></div>
                                                            <h3 className="box-title m-t0 m-b10">{formData && formData.survey.name}<span className="bg-primary"></span></h3>
                                                            <p>{formData && formData.survey.description}</p>
                                                            <div className="row">
                                                                {
                                                                    formData && formData.questions.map((survey, index) => {
                                                                        const inputType = findInputType(survey.questionType.name);
                                                                        const inputIcon = findInputIcon(survey.questionType.name);
                                                                        var surveyName = `${survey.questionType.name}${survey.id}`.replace(/\s/g, '')

                                                                        return (
                                                                            <div key={index} className={inputType === 'text' || inputType === 'email' ? 'col-lg-6' : 'col-lg-12'}>
                                                                                <div className="form-group">
                                                                                    {
                                                                                        <CustomForm
                                                                                            key={index}
                                                                                            surveyName={surveyName}
                                                                                            survey={survey}
                                                                                            errors={errors}
                                                                                            questionName={survey.name}
                                                                                            questionDescription={surveyName}
                                                                                            setIsFocused={setIsFocused}
                                                                                            isFocused={isFocused}
                                                                                            inputType={inputType}
                                                                                            handleChange={handleChange}
                                                                                            handleBlur={handleBlur}
                                                                                            label={false}
                                                                                            setSelected={setSelected}
                                                                                            selected={selected}
                                                                                            questionOption={survey.questionOption}
                                                                                            inputIcon={inputIcon}
                                                                                            values={values}
                                                                                            setFieldValue={setFieldValue}
                                                                                            questionId={survey.id}
                                                                                            questionTypeId={survey.questionType.id}
                                                                                        />
                                                                                    }
                                                                                    {touched[surveyName] && errors[surveyName] && <small className='text-danger'>{errors[surveyName]}</small>}
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                                <div className="col-lg-12">
                                                                    <span>
                                                                        <div className="col-lg-12 col-md-12 col-sm-12">
                                                                            <button type="submit" name="submit" value="Submit" disabled={isAddingRecord} className="site-button button-lg d-flex justify-content-center"> {
                                                                                isAddingRecord && <SpinnerCircular color='black' size={20} thickness={100} className="mr-10" secondaryColor="white" />
                                                                            }  <span className='submit-button'>Apply for a Consultation Slot</span></button>
                                                                        </div>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                }
                                            </Form>
                                        )
                                    }
                                    }
                                </Formik>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default KickStarter